import { defineNuxtPlugin } from 'nuxt/app'

import VueScrollTo from 'vue-scrollto'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      scrollTo: VueScrollTo.scrollTo,
    },
  }
})
